


































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { BatchDetailsDto } from '../../models/batch/BatchDetailsDto';
import BatchEventDetails from './batch-event-details.vue';
import { BatchService } from '../../service/BatchService';
import BatchDeleteData from './batch-delete-data.vue';
import { DxButton, DxLoadIndicator } from 'devextreme-vue';
import dialog from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import BatchRename from '@/components/batch/batch-rename.vue';

@Component({
  components: {
    BatchEventDetails,
    BatchRename,
    BatchDeleteData,
    DxButton,
    DxLoadIndicator
  }
})
export default class BatchDetails extends Vue {
  batchService: BatchService = new BatchService();
  showBatchRename: boolean = false;

  @Prop({ required: true })
  batch!: BatchDetailsDto;

  startingAutoCoding: boolean = false;
  async startAutoCoding() {
    this.startingAutoCoding = true;
    await this.batchService.startAutoCoding(this.batch.BatchId)
      .then(this.startAutoCodingSuccess)
      .catch(await this.startAutoCodingError);
    this.startingAutoCoding = false;
  }

  startingAzureCoding: boolean = false;
  async startAzureCoding() {
    this.startingAzureCoding = true;
    await this.batchService.startAzureCoding(this.batch.BatchId)
      .then(this.startAzureCodingSuccess)
      .catch(await this.startAzureCodingError);
    this.startingAzureCoding = false;
  }

  startingPostProcessing: boolean = false;
  async startPostProcessing() {
    this.startingPostProcessing = true;
    await this.batchService.startPostProcessing(this.batch.BatchId)
      .then(this.startPostProcessingSuccess)
      .catch(await this.startPostProcessingError);
    this.startingPostProcessing = false;
  }

  batchCompleted: boolean = false;
  completingBatch: boolean = false;
  async completeBatch() {
    this.completingBatch = true;
    await this.batchService.completeBatch(this.batch.BatchId)
      .then(() => { this.showMessage(null, 'The batch has been completed'); this.batchCompleted = true })
      .catch(await this.completeBatchError);
    this.completingBatch = false;
  }

  showingDeleteBatchData: boolean = false;
  showDeleteBatchData() {
    this.showingDeleteBatchData = true;
  }

  hidingDeleteBatchData() {
    this.showingDeleteBatchData = false;
    this.$emit("hidingDeleteBatchData");
  }

  renameBatch() {
    this.showBatchRename = true;
  }

  closeBatchRename() {
    this.showBatchRename = false;
  }

  startAutoCodingSuccess() {
    notify('Auto coding started', 'success', 3000);
  }

  startAzureCodingSuccess() {
    notify('Azure auto coding started', 'success', 3000);
  }

  startPostProcessingSuccess() {
    notify('Post processing started', 'success', 3000);
  }

  async startAutoCodingError(error: any) {
    await this.showMessage(error, 'An error occurred starting auto coding');
  }

  async startAzureCodingError(error: any) {
    await this.showMessage(error, 'An error occurred starting azure auto coding');
  }

  async startPostProcessingError(error: any) {
    await this.showMessage(error, 'An error occurred starting post processing');
  }

  async completeBatchError(error: any) {
    await this.showMessage(error, 'An error occurred completing the batch');
  }

  async showMessage(error: any, message: any) {
    let type = error ? 'Error' : 'Success';

    if (error) {
      message += error.Message ? ': ' + error.Message : '.';
    }

    await dialog.alert(message, type);
  }
}
